window.$ = window.jQuery = require('jquery');

import { Cerca } from './cerca';

window.iniciarMapaTelaCerca = () => {
    const cerca = new Cerca();
    return cerca.iniciarMapa();
};
